import React, { useContext, useState } from "react";
import Grid from "@mui/material/Grid2";
import styles from "../../Styles/ComponentStyles/MainPages/dashboard.module.scss";
import globalStyles from "../../Styles/global.module.scss";
import Icons from "../../Utils/Layout/Icons/Icons";
import { IconButton, Typography, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useIsBelow1200 } from "../../Utils/Constant/Constant";
import { GlobalUserContext, GlobalUserContextPayload } from "../../Context/GlobalUserDetailContext";

interface pdfCardsProps {
  pdfMainName: string;
  pdfSubName: string;
  pdfUrl: string;
  data: any;
  flagOpenEditPdfDialog: () => void;
  flagOpenDeletePdfDialog: () => void;
  flagOpenPdfDialog: () => void
}

const PdfCards = (props: pdfCardsProps) => {
  const {
    userProfileDetails
  } = useContext(GlobalUserContext) as GlobalUserContextPayload

  const isProfileAdmin = userProfileDetails?.user?.flagAdmin

  const { pdfMainName, pdfSubName, data, flagOpenEditPdfDialog, flagOpenDeletePdfDialog, flagOpenPdfDialog } = props;
  const isBelow1200 = useIsBelow1200();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Grid container>
        {isBelow1200 ? (
          <>
            <Grid size={{ xs: 12 }} >
              <Grid
                container
                sx={{ justifyContent: "space-between", alignItems: "center" }}
              >
                <Grid size={{ xs: 3 }} className={`${styles.pdfImgItem}`} >
                  {data?.google_storage_file_id ? (
                    <div style={{ width: "fit-content", cursor: "pointer" }} onClick={flagOpenPdfDialog}>
                      {data.thumbnail && data?.thumbnail?.google_storage_public_url ? (
                        <img src={data?.thumbnail?.google_storage_public_url} style={{ height: '42px', width: '42px', objectFit: "fill" }} alt="" />
                      ) : (
                        <Icons iconName="pdf-icon" iconWidth="40px" iconHeight="40px" iconColor="#485977" />
                      )}
                    </div>
                  ) : (
                    <a href={data?.hyperlink} target="_blank" rel="noopener noreferrer">
                      <Icons iconName="hyperlink-icon" iconWidth="40px" iconHeight="40px" />
                    </a>
                  )}
                </Grid>
                <Grid size={{ xs: 7 }} className={`${styles.pdfContentItem}`}>
                  <Grid container>
                    <Grid
                      size={{ xs: 11 }}
                      className={`${styles.pdfNameItem} ${globalStyles.gblOnelineEllipsis}`}
                      sx={{ margin: "5px 0px 5px" }}
                    >
                      <Typography component={"span"}>{pdfMainName}</Typography>
                    </Grid>
                    {isProfileAdmin &&
                      <Grid size={{ xs: 1 }} className={`${styles.pdfMoreIcon}`}>
                        <IconButton sx={{ padding: "0px", alignItems: "flex-start" }} onClick={handleClick}>
                          <MoreVertIcon sx={{ fontSize: "16px", color: "black" }} />
                        </IconButton>
                        <Menu
                          id="long-menu"
                          MenuListProps={{
                            'aria-labelledby': 'long-button',
                          }}
                          anchorEl={anchorEl}
                          open={open}
                          onClose={handleClose}
                          slotProps={{
                            paper: {
                              style: {
                                width: '100px',
                              },
                            },
                          }}
                        >
                          <MenuItem onClick={() => {
                            flagOpenEditPdfDialog()
                            handleClose()
                          }} >Edit</MenuItem>

                          <MenuItem onClick={() => {
                            flagOpenDeletePdfDialog();
                            handleClose()
                          }} >Delete</MenuItem>
                        </Menu>
                      </Grid>}
                    <Grid
                      size={{ xs: 12 }}
                      className={`${styles.pdfSubNameItem} ${globalStyles.gblOnelineEllipsis}`}
                    >
                      <Typography component={"span"}>{pdfSubName}</Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </>
        ) : (
          <>
            <Grid size={{ xs: 12 }} >
              <Grid container>
                <Grid size={{ xs: 8 }} >
                  {data?.google_storage_file_id ? (
                    <div style={{ width: "fit-content", cursor: "pointer" }} onClick={flagOpenPdfDialog}>
                      {data.thumbnail && data?.thumbnail?.google_storage_public_url ? (
                        <img src={data?.thumbnail?.google_storage_public_url} style={{ height: '42px', width: '42px', objectFit: "fill" }} alt="" />
                      ) : (
                        <Icons iconName="pdf-icon" iconWidth="40px" iconHeight="40px" iconColor="#485977" />
                      )}
                    </div>
                  ) : (
                    <a href={data?.hyperlink} target="_blank" rel="noopener noreferrer">
                      <Icons iconName="hyperlink-icon" iconWidth="40px" iconHeight="40px" />
                    </a>
                  )}
                </Grid>
                {isProfileAdmin &&
                  <Grid size={{ xs: 4 }} className={`${styles.pdfMoreIcon}`}>
                    <IconButton sx={{ padding: "0px", alignItems: "flex-start" }} onClick={handleClick}>
                      <MoreVertIcon sx={{ fontSize: "30px", color: "black" }} />
                    </IconButton>
                    <Menu
                      id="long-menu"
                      MenuListProps={{
                        'aria-labelledby': 'long-button',
                      }}
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleClose}
                      slotProps={{
                        paper: {
                          style: {
                            width: '100px',
                          },
                        },
                      }}
                    >
                      <MenuItem onClick={() => {
                        flagOpenEditPdfDialog()
                        handleClose()
                      }} >Edit</MenuItem>

                      <MenuItem onClick={() => {
                        flagOpenDeletePdfDialog();
                        handleClose()
                      }} >Delete</MenuItem>
                    </Menu>
                  </Grid>
                }
                <Grid
                  size={{ xs: 12 }}
                  className={`${styles.pdfNameItem}`}
                  sx={{ margin: "5px 0px 5px" }}
                >
                  <Typography component={"span"} className={`${globalStyles.gblOnelineEllipsis}`}>{pdfMainName}</Typography>
                </Grid>
                <Grid size={{ xs: 12 }} className={`${styles.pdfSubNameItem}`}>
                  <Typography component={"span"} className={`${globalStyles.gblTwolineEllipsis}`}>{pdfSubName}</Typography>
                </Grid>
              </Grid>
            </Grid>
          </>
        )}
      </Grid>
    </>
  );
};

export default PdfCards;
